import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { CatalogoImmaginiMortiComponent }      from './catalogo/catalogo-immagini-morti.component';
import { CatalogoImmaginiBattezzatiComponent }      from './catalogo/catalogo-immagini-battezzati.component';
import { CatalogoMortiComponent }      from './catalogo/catalogo-morti.component';
import { CatalogoBattezzatiComponent }      from './catalogo/catalogo-battezzati.component';
import {DettaglioImmagineMortoComponent} from './dettaglio/dettaglio-immagine-morto.component';
import {DettaglioImmagineBattezzatoComponent} from './dettaglio/dettaglio-immagine-battezzato.component';
import {CatalogoMatrimoniComponent} from './catalogo/catalogo-matrimoni.component';


const routes: Routes = [
  { path: '', redirectTo: '/catalogoImmaginiMorti', pathMatch: 'full' },
  { path: 'catalogoImmaginiMorti',     component: CatalogoImmaginiMortiComponent },
  { path: 'catalogoImmaginiBattezzati',     component: CatalogoImmaginiBattezzatiComponent },
  { path: 'mortiLista',     component: CatalogoMortiComponent },
  { path: 'battezzatiLista',     component: CatalogoBattezzatiComponent },
  { path: 'dettaglioImmagineMorto/:id',     component: DettaglioImmagineMortoComponent },
  { path: 'dettaglioImmagineBattezzato/:id',     component: DettaglioImmagineBattezzatoComponent },
  { path: 'matrimoni',     component: CatalogoMatrimoniComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/app-routing.module.ts